export const API_URL = "https://adecco-api-s3g2757oya-ey.a.run.app/";
//export const API_URL = "http://localhost:8080/";
//export const API_URL = "https://dev-api-davide.plesh.co/";

export const colorAreas = {
    "ROSSO": "lightcoral",
    "AZZURRO": "lightblue",
    "GIALLO": "gold",
    "VIOLA": "#c5acf8",
}